import { supabase } from '../supabaseClient'
import { getMexicoDateString } from '../dateUtils'

// Mantiene las funciones de cierre de sesiones que vivian en sync.js.
// Sync con Google Sheets fue eliminado en Fase 8 pero estas funciones
// son utilidad operativa independiente y se conservan.

export const closeSessionsNow = async (fechaCorte = null) => {
  try {
    const payload = fechaCorte ? { fecha_corte: fechaCorte } : {}
    const { data, error } = await supabase.functions.invoke('close-sessions', {
      body: payload
    })

    if (error) {
      throw new Error(`Error en Edge Function: ${error.message || JSON.stringify(error)}`)
    }

    return { data, error: null }
  } catch (error) {
    const errorMessage = error.message || error.toString()
    return { data: null, error: { message: errorMessage } }
  }
}

export const getClosableSessionsSummary = async (fechaCorte = null) => {
  try {
    const fecha = fechaCorte || getMexicoDateString()
    const { data, error } = await supabase
      .from('sesiones')
      .select('id, tipo, estatus, fecha')
      .in('tipo', ['entrenamiento', 'juego'])
      .in('estatus', ['programado', 'en_curso'])
      .lt('fecha', fecha)

    if (error) throw error

    const summary = (data || []).reduce(
      (acc, row) => {
        if (row.tipo === 'juego') acc.juegos += 1
        if (row.tipo === 'entrenamiento') acc.entrenamientos += 1
        return acc
      },
      { entrenamientos: 0, juegos: 0 }
    )

    return { data: { ...summary, total: (data || []).length, fecha_corte: fecha }, error: null }
  } catch (error) {
    return { data: null, error }
  }
}
